import script from "./application.vue?vue&type=script&setup=true&lang=js"
export * from "./application.vue?vue&type=script&setup=true&lang=js"

import "./application.vue?vue&type=style&index=0&id=6fa0735b&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa0735b"]])

export default __exports__